require('./cmTransferOriginContractsSummaryStep2.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { ContentBox } = require('commonsComponents/contentBox');

// @components
const {
    OneLineSymbolAmount,
} = require('commonsComponents/oneLineSymbolAmount');

// @helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const {
    formatAmountObject,
    getPlainAmountObject,
} = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const {
    CM_EUR_CURRENCY_SYMBOL,
    CM_WIZARD_FIRST_STEP,
} = require('../../constants/constants');

class CmTransferOriginContractsSummaryStep2Table extends React.Component {
    constructor(props) {
        super(props);
    }

    buildTableHeader(upsideInfo, isTransferWithMoney) {
        let firstHeader;
        let secondHeader;
        let thirdHeader;
        let lastHeader;
        let lastHeaderContent;

        if (upsideInfo) {
            firstHeader =
                'brokerCM-transferOriginContractsSummaryFundToTransferHeader';
            secondHeader = 'brokerCM-transferOriginContractsSummaryIsinHeader';
            thirdHeader =
                'brokerCM-transferOriginContractsSummaryContractNumberHeader';
            lastHeader =
                'brokerCM-transferOriginContractsSummaryActualValueHeader';
            lastHeaderContent = (
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary-step2__header-cell--last"
                >
                    <FormattedText
                        value={lastHeader}
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary-step2__header-content"
                    />
                </OKTableCell>
            );
        } else {
            firstHeader =
                'brokerCM-transferOriginContractsSummaryAssociatedAccountHeader';
            secondHeader =
                'brokerCM-transferOriginContractsSummaryBalanceLeftHeader';
            thirdHeader =
                'brokerCM-transferOriginContractsSummaryContractNumberHeader';
            if (!isTransferWithMoney) {
                lastHeaderContent = (
                    <OKTableCell
                        asHeader={true}
                        className="cm-transfer-origin-contracts-summary-step2__header-cell--last"
                    />
                );
            } else {
                lastHeaderContent = (
                    <OKTableCell
                        asHeader={true}
                        className="cm-transfer-origin-contracts-summary-step2__header-cell--last"
                    >
                        {formatText(
                            'brokerCM-transferOriginContractsSummaryAddMoneyHeader',
                        )}
                    </OKTableCell>
                );
            }
        }

        return (
            <OKTableRow
                asHeader={true}
                className="cm-transfer-origin-contracts-summary-step2__header-row hidden-xs"
            >
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary-step2__header-cell--first"
                >
                    <FormattedText
                        value={firstHeader}
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary-step2__header-content"
                    />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary-step2__header-cell--second"
                >
                    <FormattedText
                        value={secondHeader}
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary-step2__header-content"
                    />
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="cm-transfer-origin-contracts-summary-step2__header-cell--third"
                >
                    <FormattedText
                        value={thirdHeader}
                        format="uppercase"
                        className="cm-transfer-origin-contracts-summary-step2__header-document-content"
                    />
                </OKTableCell>
                {lastHeaderContent}
            </OKTableRow>
        );
    }

    buildTableBody(upsideInfo, isTransferWithMoney) {
        const {
            immCmWalletBuy,
            immAccounts,
            originFundMatchedInPortfolio,
        } = this.props;
        let firstValue;
        let secondValue;
        let thirdValue;
        let lastValueContent;
        const originFundInfo = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'originFundInfo',
        ]);
        const originFund = originFundInfo.get('infoFondosPosicionGlobal');

        if (upsideInfo) {
            firstValue = originFund.get('nombre');
            secondValue = originFund.getIn(['instrumentInfo', 'instrumentId']);
            thirdValue = getLastNChars(
                originFund.getIn(['contrato', 'numeroContrato']),
            );
            const lastValue = originFund.getIn([
                'importes',
                'total',
                'valor',
                'importeEur',
                'importe',
            ]);
            const lastValueFormatted = lastValue
                ? lastValue + CM_EUR_CURRENCY_SYMBOL
                : formatText('broker-notAvailableData');

            lastValueContent = (
                <OKTableCell
                    className={
                        'cm-transfer-origin-contracts-summary-step2__body-cell--last'
                    }
                >
                    <span className="cm-transfer-origin-contracts-summary-step2__cell-content-last">
                        {lastValueFormatted}
                    </span>
                </OKTableCell>
            );
        } else {
            let accountNumber = immCmWalletBuy.getIn([
                'steps',
                CM_WIZARD_FIRST_STEP,
                'accountNumber',
            ]);
            if (accountNumber === '') {
                accountNumber = immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                    'accountNumberTransfer',
                ]);
            }

            const account = immAccounts.getIn(['byId', accountNumber]);
            const availableBalance = account.getIn([
                'balances',
                'availableBalance',
            ]);
            const associatedAccountBalance = getPlainAmountObject(
                availableBalance,
            );
            firstValue = account.get('alias');
            secondValue = (
                <OneLineSymbolAmount
                    amountObject={associatedAccountBalance}
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(
                        associatedAccountBalance,
                        true,
                    )}
                />
            );
            thirdValue = getLastNChars(account.get('fullContractNumber'));

            if (!isTransferWithMoney) {
                lastValueContent = (
                    <OKTableCell className="cm-transfer-origin-contracts-summary-step2__body-cell--last" />
                );
            } else {
                const step1 = immCmWalletBuy.getIn([
                    'steps',
                    CM_WIZARD_FIRST_STEP,
                ]);
                const missingTransferFundAmount = step1.get(
                    'missingTransferFundAmount',
                );
                const amount = {
                    amount: missingTransferFundAmount,
                    currency: 'EUR',
                };

                lastValueContent = (
                    <OKTableCell className="cm-transfer-origin-contracts-summary-step2__body-cell--last">
                        <span className="cm-transfer-origin-contracts-summary-step2__cell-content-last">
                            <OneLineSymbolAmount
                                amountObject={amount}
                                key="cmWalletBuyStep2AvailableAmount"
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(
                                    amount,
                                    true,
                                )}
                            />
                        </span>
                    </OKTableCell>
                );
            }
        }

        return (
            <OKTableRow
                className={
                    originFundMatchedInPortfolio && upsideInfo
                        ? 'cm-transfer-origin-contracts-summary-step2__body-cell-matched'
                        : 'cm-transfer-origin-contracts-summary-step2__body-cell'
                }
            >
                <OKTableCell
                    className={
                        'cm-transfer-origin-contracts-summary-step2__body-cell--first'
                    }
                >
                    <span className="cm-transfer-origin-contracts-summary-step2__cell-content-first">
                        {firstValue}
                    </span>
                </OKTableCell>
                <OKTableCell
                    className={
                        'cm-transfer-origin-contracts-summary-step2__body-cell--second'
                    }
                >
                    <span className="cm-transfer-origin-contracts-summary-step2__cell-content-second">
                        {secondValue}
                    </span>
                </OKTableCell>
                <OKTableCell
                    className={
                        'cm-transfer-origin-contracts-summary-step2__body-cell--third'
                    }
                >
                    <span className="cm-transfer-origin-contracts-summary-step2__cell-content-third">
                        {thirdValue}
                    </span>
                </OKTableCell>
                {lastValueContent}
            </OKTableRow>
        );
    }

    render() {
        const { immCmWalletBuy } = this.props;
        const upsideInfo = true;
        const step1 = immCmWalletBuy.getIn(['steps', CM_WIZARD_FIRST_STEP]);
        const isTransferWithMoney = step1.get('isTransferWithMoney');
        const tableHeaderFund = this.buildTableHeader(upsideInfo);
        const tableBodyFund = this.buildTableBody(upsideInfo);
        const tableHeaderAssociatedAccount = this.buildTableHeader(
            !upsideInfo,
            isTransferWithMoney,
        );
        const tableBodyAssociatedAccount = this.buildTableBody(
            !upsideInfo,
            isTransferWithMoney,
        );

        return (
            <ContentBox
                className="cm-transfer-origin-contracts-summary-step2"
                hasShadow={false}
            >
                <OKTable>
                    <thead>{tableHeaderFund}</thead>
                    <tbody>{tableBodyFund}</tbody>
                </OKTable>
                <div className="cm-transfer-origin-contracts-summary-step2__table-separator" />
                <OKTable>
                    <thead>{tableHeaderAssociatedAccount}</thead>
                    <tbody>{tableBodyAssociatedAccount}</tbody>
                </OKTable>
            </ContentBox>
        );
    }
}

CmTransferOriginContractsSummaryStep2Table.propTypes = {
    immCmWalletBuy: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    originFundMatchedInPortfolio: PropTypes.string,
};

module.exports = CmTransferOriginContractsSummaryStep2Table;
